import { get } from '../../utils/http';

export const getQaStatistics = async (params: any) => {
  const res = await get('api/dataBoard/getQaStatistics', params);
  return res;
};

export const getUserProductivity = async (params: any) => {
  const res = await get('api/dataBoard/getUserProductivity', params);
  return res;
};
